import { render, staticRenderFns } from "./ElectricalDamageFoodAmount.vue?vue&type=template&id=e6a37f72"
import script from "./ElectricalDamageFoodAmount.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageFoodAmount.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageFoodAmount.vue?vue&type=style&index=0&id=e6a37f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports